export const FileUploadType = {
	// All Types:
	AnyFile: '*',

	// Document Types:
	Document: 'application/*',
	Pdf: '.pdf',
	Doc: '.doc',
	Docx: '.docx',
	Xls: '.xls',
	Xlsx: '.xlsx',
	Csv: '.csv',

	// Image Types:
	Image: 'image/*',
	Jpg: '.jpg',
	Jpeg: '.jpeg',
	Png: '.png',
	Gif: '.gif',
	Svg: '.svg',
} as const;

export type FileUploadType = (typeof FileUploadType)[keyof typeof FileUploadType];

/* -------------------------------------------------------------------------------------------------------------- */
export function toFileUploadType(type: string): FileUploadType {
	if (type === '*') return FileUploadType.AnyFile;
	if (type.startsWith('.')) type = type.substring(1);
	if (type.startsWith('application/')) type = type.substring('application/'.length);
	if (type.startsWith('image/')) type = type.substring('image/'.length);
	type = type.toLowerCase();

	return Object.values(FileUploadType).find(fileType => fileType.replace('.', '').toLowerCase() === type) || FileUploadType.AnyFile;
}

export type IStoredFile = {
	data: string;
	type: string;
	name?: string;
	webEncode?: string;
	fileEncode?: string;
};
